import { useCallback, useState } from 'react';
/**
 * @function
 * Нужна для простоты использования булевых значений
 * @return [значение, поставить false, поставить true]
 */
export function useBooleanState(dflt) {
    const [state, setState] = useState(dflt);
    const setFalse = useCallback(() => setState(false), [setState]);
    const setTrue = useCallback(() => setState(true), [setState]);
    const toggle = useCallback(() => setState((current) => !current), [setState]);
    return [state, setFalse, setTrue, toggle];
}
